"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const material_1 = require("@mui/material");
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const Wrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10vh;

  h3,
  p {
    text-align: center;
  }

  h3 {
    font-size: 4vmin;
    font-weight: 400;
    margin-top: 4vmin;
    margin-bottom: 1.7vmin;
  }

  p {
    margin-top: 0px;
  }

  .repeat {
    font-size: 3.2vmin;
    margin-bottom: 1.3vmin;
  }

  .hint {
    margin-bottom: 5vmin;
    font-size: 2.74vmin;
  }

  img {
    display: block;
    margin: 0 auto;
    height: 7vmin;
  }
`;
const ButtonWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  max-width: 520px;
  margin: 0 auto;
  width: 100%;

  button {
    margin-bottom: 1.7vmin;
  }
`;
const CardActivationSuccessfull = ({ statusData, baseUrl, history }) => {
    if (!statusData) {
        return null;
    }
    const { texts } = statusData;
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement("img", { src: "/images/other/checkmark.svg", alt: "activation-success" }),
        texts && texts.headline && react_1.default.createElement("h3", null, texts.headline),
        texts && texts.text && react_1.default.createElement("p", { className: "repeat" }, texts.text),
        texts && texts.hint && react_1.default.createElement("p", { className: "hint" }, texts.hint),
        react_1.default.createElement(ButtonWrapper, null,
            texts && texts.skipButton && (react_1.default.createElement(material_1.Button, { fullWidth: true, variant: "outlined", size: "large", onClick: () => {
                    history.push(`${baseUrl}/guest_journey/kiosk/keycard_activation_flow/process_completed`);
                } },
                " ",
                texts.skipButton)),
            texts && texts.anotherCardButton && (react_1.default.createElement(material_1.Button, { fullWidth: true, variant: "contained", size: "large", onClick: () => {
                    history.push(`${baseUrl}/guest_journey/kiosk/keycard_activation_flow/activate_card`);
                } },
                " ",
                texts.anotherCardButton)))));
};
const mapStoreToProps = (store) => ({
    baseUrl: store.getValue("baseUrl"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(CardActivationSuccessfull));
